<template>
  <dash-board-layout :active="8" :title="true">
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header border-0">
            <h4 class="card-title">Order</h4>
          </div>
          <div class="card-body pt-0">
            <div class="transaction-table">
              <div class="table-responsive">
                <table class="table mb-0 table-responsive-sm">
                  <tbody>
                    <tr v-for="(item, index) in data" :key="index">
                      <td>
                        <span class="buy-thumb" v-if="item.side == 'BUY'"
                          ><i class="la la-arrow-up"></i
                        ></span>
                        <span class="sold-thumb" v-if="item.side == 'SELL'"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>
                      <td>
                        <span
                          :class="`badge badge-${
                            item.side == 'BUY' ? 'success' : 'danger'
                          }`"
                          >{{ item.order_no }}</span
                        >
                      </td>
                      <td>
                        <i :class="`cc ${item.symbol}`"></i> {{ item.order_no }}
                      </td>
                      <td>
                        <i :class="`cc ${item.symbol}`"></i> {{ item.currency }}
                      </td>
                      <td>{{ item.orderNo }}</td>
                      <td
                        :class="`text-${
                          item.side == 'BUY' ? 'success' : 'danger'
                        }`"
                      >
                        {{ item.side == 'BUY' ? "+" : "-"
                        }}{{ formatNumber(item.coin_count, 4, ",") }}
                        {{ item.currency }}
                      </td>
                      <td>
                        {{ formatNumber(item.amount, 2, ",") }}
                        {{ item.legal_currency }}
                      </td>
                      <td style="text-align: right">
                        {{ item.status }}
                      </td>
                    </tr>

                    <!-- <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>

                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc BTC"></i> BTC</td>
                      <td>Using - Bank *******5264</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="buy-thumb"
                          ><i class="la la-arrow-up"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-success">Buy</span>
                      </td>
                      <td><i class="cc LTC"></i> LTC</td>
                      <td>Using - Card *******8475</td>
                      <td class="text-success">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc XRP"></i> XRP</td>
                      <td>Using - Card *******8475</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="buy-thumb"
                          ><i class="la la-arrow-up"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-success">Buy</span>
                      </td>
                      <td><i class="cc DASH"></i> DASH</td>
                      <td>Using - Card *******2321</td>
                      <td class="text-success">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc BTC"></i> BTC</td>
                      <td>Using - Card *******2321</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>

                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc BTC"></i> BTC</td>
                      <td>Using - Bank *******5264</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="buy-thumb"
                          ><i class="la la-arrow-up"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-success">Buy</span>
                      </td>
                      <td><i class="cc LTC"></i> LTC</td>
                      <td>Using - Card *******8475</td>
                      <td class="text-success">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc XRP"></i> XRP</td>
                      <td>Using - Card *******8475</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="buy-thumb"
                          ><i class="la la-arrow-up"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-success">Buy</span>
                      </td>
                      <td><i class="cc DASH"></i> DASH</td>
                      <td>Using - Card *******2321</td>
                      <td class="text-success">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr>
                    <tr>
                      <td>
                        <span class="sold-thumb"
                          ><i class="la la-arrow-down"></i
                        ></span>
                      </td>
                      <td>
                        <span class="badge badge-danger">Sold</span>
                      </td>
                      <td><i class="cc BTC"></i> BTC</td>
                      <td>Using - Card *******2321</td>
                      <td class="text-danger">-0.000242 BTC</td>
                      <td>-0.125 USD</td>
                    </tr> -->
                  </tbody>
                </table>
              </div>
              <div style="text-align: center; margin: 15px">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pager.total"
                  :page-size="per_page"
                  :current-page="page"
                  @current-change="handlePageChange"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
import { list } from "../../plugins/api/order";
import { formatNumber } from "../../plugins/operation";
export default {
  components: { DashBoardLayout },
  mounted() {
    this.getdata();
  },
  data() {
    return {
      data: [],
      allLoaded: false,
      topStatus: "",
      page: 1,
      per_page: 10,
      pager: {},
    };
  },
  created() {},
  methods: {
    formatNumber(num, precision, separator) {
      return formatNumber(num, precision, separator);
    },
    back() {
      this.$router.go(-1);
    },
    handlePageChange(val) {
      console.log(val);
      this.page = val;
      this.getdata();
    },
    getdata() {
      list({ page: this.page, per_page: this.per_page }).then((res) => {
        if (res.code == 0) {
          this.data = res.data;
          this.pager = res.meta.pagination;
          this.curPage = 1;
        }
      });
    },
  },
};
</script>
